import * as React from 'react';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { outlinedInputClasses } from '@mui/material';
import { getRequest, postRequest, putRequest } from "../../services/ApiServices";
import { useState, useEffect } from "react";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import { propsToClassKey } from '@mui/styles';
import { getCookie } from "../../services/Cookies";
import { FilterObj } from '../CommonComponents/globalfilterObj';
export default function Samplenumber(props) {
    const [filteredString, setValue] = useState("");
    const [GlobalFilterSettingValue, setGlobalFilterSettingValue] = React.useState(localStorage.getItem('GlobalFilterSetting'));
    const [selectedvalue, setselectedvalue] = React.useState([]);
    const [formObj, setFormObj] = useState(FilterObj);
    const [sampleNumber, setsampleNumber] = React.useState([]);
    const { reset, screen, type } = props;
    const fetchSampleNumberData = async (event) => {
        //
        let customerKey = localStorage.getItem("currentpagecustomer");
        let vesselKey = localStorage.getItem("currentshipnameimo");
        let FqtLabkey = localStorage.getItem("currentFqtLabkey");
        if (customerKey == "") {
            customerKey = null;
        }
        if (vesselKey == "") {
            vesselKey = null;
        }
        if (FqtLabkey == "") {
            FqtLabkey = null;
        }
        const searchStr = event.target.value;
        setValue(searchStr);
        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `CommonComponent/SampleNumber/${customerKey}/${vesselKey}/${FqtLabkey}/${searchStr}`;

        await getRequest(url)
            .then((res) => {
                console.log("Responce", res);
                if (res.status == 200) {
                    let data = res?.data || [];
                    let result = data?.map((a, i) => {
                        return { id: a?.sampleControlNoCd, name: a?.sampleControlNoCd };
                    });
                    if (selectedvalue) {
                        selectedvalue.forEach((val, i) => {
                            result = result.filter((ele) => ele.name != val.name)
                        })
                    }
                    setsampleNumber(result);
                } else {
                    // ToastError(res.data.message);
                }
            })
            .catch((error) => {

                //ToastError(error.response.data.message);
            });
    }
    const handelChange = (event, newValue, type) => {

        props.onChange(newValue);
        const filteredFqtsamplenumber = {
            ...formObj,
            Fqtsamplenumber: newValue
        };
        setFormObj(filteredFqtsamplenumber);
        setselectedvalue(newValue);
        setValue("");
        if (screen !== "GlobalFilter") {
            let Obj = JSON.parse(localStorage.getItem('FilterSetting'));
            Obj = {
                ...Obj,
                Fqtsamplenumber: newValue
            }
            localStorage.setItem("FilterSetting", JSON.stringify(Obj));
        }
    }
    const defaultValue = (val) => {
        ////
        let filtervalue = JSON.parse(localStorage.getItem('FilterSetting'));
        if (filtervalue !== "" && filtervalue !== undefined && filtervalue !== null && filtervalue !== "null" && screen !== "GlobalFilter") {
            const Obj = {
                ...formObj,
                Fqtsamplenumber: filtervalue.Fqtsamplenumber
            };
            setFormObj(Obj);
            setselectedvalue(filtervalue.Fqtsamplenumber);
        }
        else if (val !== "" && val !== undefined && val !== "null") {
            let Obj = JSON.parse(val);
            setFormObj(Obj);
            setselectedvalue(Obj.Fqtsamplenumber);
            console.log('getcookievalue', formObj)
        } else {
            setFormObj({});
        }
    }
    React.useEffect(() => {
        //
        if (reset > 0)
            defaultValue(GlobalFilterSettingValue);

    }, [reset]);
    React.useEffect(() => {
        ////
        defaultValue(GlobalFilterSettingValue);
    }, []);
    return (
        <Stack spacing={3}>


            <Autocomplete
                multiple
                id="size-small-standard-multi"
                size="small"
                // fullWidth Fqtsamplenumber
                value={formObj?.Fqtsamplenumber || []}
                getOptionSelected={(option, value) => option?.name === value?.name}
                options={sampleNumber}
                getOptionLabel={(option) => option.name}
                //defaultValue={[top100Films[13]]}
                onChange={(event, newValue) => handelChange(event, newValue)}
                inputValue={filteredString}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="standard"
                        label="Sample Number"
                        placeholder=""
                        onChange={fetchSampleNumberData}

                    />
                )}
            />



        </Stack>
    );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
